import { icons, logos } from '../images';

const platformIcons = {
  facebookmessenger: {
    type: logos,
    icon: 'facebook-messenger',
  },
  instagram: {
    type: logos,
    icon: 'instagram',
  },
  apexchat: {
    type: logos,
    icon: 'apexchat',
  },
  sitestaffchat: {
    type: logos,
    icon: 'sitestaffchat',
  },
  reviewloop: {
    type: icons,
    icon: 'icon-reviewloop',
  },
};

const typeIcons = {
  call: 'call',
  phone_call: 'call',
  phone: 'call',
  email: 'email',
  note: 'note',
  text: 'text',
  todo: 'todo',
  form: 'form',
  web_form: 'form',
};

const getMessageIcon = (message, options = {}) => {
  const type = typeof message === 'string' ? message : message.type;
  const singleType = String(type || '')
    .replace(/s$/, '')
    .toLowerCase();
  const platformCode = message.platform_code || (message.platform || {}).code;

  const iconMatch = platformIcons[platformCode] || typeIcons[singleType];
  if (iconMatch && iconMatch.type) {
    return iconMatch.type[iconMatch.icon];
  }
  let name = iconMatch || type;
  if (options.light) {
    name = `${name}-light`;
  }
  if (options.raster) {
    name = `${name}-raster`;
  }
  return icons[name];
};

export default getMessageIcon;
